import _ from 'lodash'

export const authInitialized = state => _.get(state, 'auth.initialized', false)
export const authBootstrapFailed = state => _.get(state, 'auth.bootstrapFailed', false)
export const currentUser = state => _.get(state, 'auth.currentUser')
export const currentOrganization = state => _.get(state, 'auth.currentOrganization')
export const currentOrganizationId = state => _.get(state, 'auth.currentOrganization.id')
export const currentProfile = state => _.get(state, 'auth.currentProfile')
export const isSwitchingUser = state => _.get(state, 'auth.switchingUser', false)
